import { useTranslation } from "react-i18next";

import { Alert, Stack, Typography } from "@mui/material";

export function OverdrawnWarningBox() {
  const { t } = useTranslation();

  return (
    <Alert severity="error" icon={false}>
      <Stack gap={3}>
        <Typography variant="body2">
          {t("clients.client.debtSettlement.assetInventory.section1.overdrawnWarningParagraph1")}
        </Typography>
        <Typography variant="body2" fontWeight={"bold"}>
          {t("clients.client.debtSettlement.assetInventory.section1.overdrawnWarningParagraph2")}
        </Typography>
        <Typography variant="body2">
          {t("clients.client.debtSettlement.assetInventory.section1.overdrawnWarningParagraph3")}
        </Typography>
      </Stack>
    </Alert>
  );
}
